import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyOrdersDashboardComponent } from './my-orders-dashboard/my-orders-dashboard.component';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { CmsCommonModule } from '../cms-common/cms-common.module';
import { FormsModule } from '@angular/forms';
import { MyOrdersLeftSectionComponent } from './my-orders-left-section/my-orders-left-section.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { RouterModule } from '@angular/router';
import { FullCalendarModule } from '@fullcalendar/angular'; 
import {MatTooltip} from '@angular/material/tooltip'

import {UkMyOrdersLeftSectionComponent} from './uk-my-orders-left-section/uk-my-orders-left-section.component';
import { OrdersCartbannerComponent } from './orders-cartbanner/orders-cartbanner.component';
import { OrdersCartReviewPageComponent } from './orders-cart-review-page/orders-cart-review-page.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
  declarations: [
    MyOrdersDashboardComponent,
    MyOrdersLeftSectionComponent, 
    UkMyOrdersLeftSectionComponent,
    OrdersCartbannerComponent,
    OrdersCartReviewPageComponent, OrdersCartReviewPageComponent
  ],
  imports: [
    CommonModule,
    CmsCommonModule,
    I18nModule,
    FormsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatInputModule,
    MatFormFieldModule,
    MatProgressBarModule,
    FullCalendarModule,
    RouterModule,   
    MatTooltip, 
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SeqirusMyOrdersBannerComponent : {
          component: MyOrdersDashboardComponent ,
        },
        SeqirusOrderDetailsComponent:{
          component: MyOrdersLeftSectionComponent ,
        },
        SeqirusUKOrderDetailsComponent:{
          component: UkMyOrdersLeftSectionComponent ,
        },
        SeqirusSaveOrderReviewComponent: {
          component: OrdersCartReviewPageComponent,
        }
      }
    } as CmsConfig)
  ],



})
export class MyOrdersModule { }
